module.exports = __webpack_public_path__ + "static/media/reject-x.3cbd4abb.svg";